var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: { id: "addNewRoleModal", role: "dialog" },
    },
    [
      _c("div", { staticClass: "modal-dialog" }, [
        _c("div", { staticClass: "modal-content first-modal-content" }, [
          _c("div", { staticClass: "modal-header modal-bgcolor" }, [
            _c(
              "button",
              {
                staticClass: "close",
                attrs: { type: "button" },
                on: { click: _vm.cancelPermissions },
              },
              [_vm._v("×")]
            ),
            _c("div", { staticClass: "modal-title" }, [
              _vm._v(_vm._s(_vm.header)),
            ]),
            _c("hr"),
          ]),
          _c("div", { staticClass: "modal-body" }, [
            _c("div", { staticClass: "col-xs-12 col-sm-12 add-role" }, [
              _c("div", { staticClass: "row mb-12" }, [
                _vm._m(0),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-6" },
                  [
                    _c("base-input-number", {
                      attrs: {
                        placeholder: "Role Id",
                        disabled: _vm.type !== "new_role",
                        min: 1,
                        maxlength: 5,
                      },
                      model: {
                        value: _vm.role.role_id,
                        callback: function ($$v) {
                          _vm.$set(_vm.role, "role_id", _vm._n($$v))
                        },
                        expression: "role.role_id",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "row mb-12" }, [
                _vm._m(1),
                _c("div", { staticClass: "col-xs-12 col-sm-6" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.role.role_name,
                        expression: "role.role_name",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      placeholder: "Role Name",
                      disabled: _vm.type !== "new_role",
                      maxlength: "30",
                    },
                    domProps: { value: _vm.role.role_name },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.role, "role_name", $event.target.value)
                      },
                    },
                  }),
                ]),
              ]),
              _c("div", { staticClass: "row mb-12" }, [
                _vm._m(2),
                _c("div", { staticClass: "col-xs-12 col-sm-6" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.role.description,
                        expression: "role.description",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      placeholder: "Description",
                      disabled: _vm.type != "new_role",
                      maxlength: "80",
                    },
                    domProps: { value: _vm.role.description },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.role, "description", $event.target.value)
                      },
                    },
                  }),
                ]),
              ]),
              _c("div", { staticClass: "row mb-12" }, [
                _c(
                  "div",
                  {
                    staticClass: "col-sm-6 col-xs-8 disp-flex",
                    class: { "link-disabled": _vm.type != "new_role" },
                  },
                  [
                    _c("span", { staticClass: "checkbox mr-12 top-4" }, [
                      _c("label", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.role.is_active,
                              expression: "role.is_active",
                            },
                          ],
                          attrs: {
                            type: "checkbox",
                            disabled: _vm.type != "new_role",
                          },
                          domProps: {
                            value: _vm.role.is_active,
                            checked: _vm.role.is_active,
                            checked: Array.isArray(_vm.role.is_active)
                              ? _vm._i(_vm.role.is_active, _vm.role.is_active) >
                                -1
                              : _vm.role.is_active,
                          },
                          on: {
                            change: function ($event) {
                              var $$a = _vm.role.is_active,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = _vm.role.is_active,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      _vm.role,
                                      "is_active",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      _vm.role,
                                      "is_active",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(_vm.role, "is_active", $$c)
                              }
                            },
                          },
                        }),
                        _c("span", {
                          staticClass: "cr",
                          class: {
                            "cursor-not-allowed": _vm.type != "new_role",
                          },
                        }),
                      ]),
                    ]),
                    _c("span", { staticClass: "cust_label" }, [
                      _vm._v("Is Active"),
                    ]),
                  ]
                ),
              ]),
              _c("div", { staticClass: "row mb-15" }, [
                _vm._m(3),
                _c(
                  "div",
                  { staticClass: "col-sm-6 col-xs-12 custom-dropdown" },
                  [
                    _c(
                      "multiselect",
                      {
                        staticClass:
                          "multiselect-single-dropdown multiselect-multiple",
                        class: !_vm.role.account_type.length
                          ? "un-selected"
                          : "",
                        attrs: {
                          disabled: _vm.type != "new_role",
                          showLabels: false,
                          "close-on-select": false,
                          placeholder: "Select Account Type",
                          label: "account_type",
                          "track-by": "account_type",
                          multiple: true,
                          searchable: true,
                          "clear-on-select": false,
                          options: _vm.accountTypeList,
                          value: _vm.role.account_type,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "selection",
                            fn: function ({ values, isOpen }) {
                              return _c(
                                "div",
                                { staticClass: "selection-count" },
                                [
                                  !isOpen
                                    ? [
                                        _c("img", {
                                          staticClass: "image-size",
                                          attrs: {
                                            src: "/static/images/icons/filter.svg",
                                            alt: "filter-icon",
                                          },
                                        }),
                                        _c(
                                          "span",
                                          { staticClass: "selected-count" },
                                          [
                                            _vm._v(
                                              _vm._s(values.length) +
                                                " Selected"
                                            ),
                                          ]
                                        ),
                                      ]
                                    : isOpen
                                    ? [
                                        _c("img", {
                                          staticClass: "image-size",
                                          attrs: {
                                            src: "/static/images/icons/filter.svg",
                                            alt: "filter-icon",
                                          },
                                        }),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              )
                            },
                          },
                          {
                            key: "option",
                            fn: function (props) {
                              return _c("span", {}, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "d-flex",
                                    on: {
                                      input: function ($event) {
                                        return _vm.updateAccountTypes(
                                          props.option
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "checkbox inline-checkbox",
                                      },
                                      [
                                        _c("label", [
                                          _c("input", {
                                            attrs: { type: "checkbox" },
                                            domProps: {
                                              value: props.option.account_type,
                                              checked:
                                                _vm.role.account_type.includes(
                                                  props.option.account_type_id
                                                ),
                                            },
                                          }),
                                          _c("span", { staticClass: "cr" }),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        class: _vm.role.account_type.includes(
                                          props.option.account_type_id
                                        )
                                          ? "font-bold"
                                          : "font-wt-400",
                                        on: {
                                          click: function ($event) {
                                            return _vm.updateAccountTypes(
                                              props.option
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(props.option.account_type) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ])
                            },
                          },
                        ]),
                      },
                      [
                        _c(
                          "span",
                          { attrs: { slot: "noResult" }, slot: "noResult" },
                          [_vm._v("No matching data")]
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
              _vm.type == "new_role"
                ? _c("div", { staticClass: "row mr-bt-55p" }, [
                    _vm._m(4),
                    _c(
                      "div",
                      { staticClass: "col-sm-6 col-xs-12 custom-dropdown" },
                      [
                        _c(
                          "multiselect",
                          {
                            staticClass: "multiselect-single-dropdown",
                            class: !_vm.selectedRoleId ? "un-selected" : "",
                            attrs: {
                              showLabels: false,
                              "close-on-select": true,
                              "allow-empty": false,
                              searchable: true,
                              options: _vm.rolesList.map(
                                (roles) => roles.role_id
                              ),
                              "custom-label": (option) =>
                                _vm.rolesList.find(
                                  (role) => role.role_id == option
                                ).role_name,
                              placeholder: "Select Role",
                            },
                            on: {
                              input: function ($event) {
                                return _vm.getRoleBasedServices(
                                  _vm.selectedRoleId
                                )
                              },
                            },
                            model: {
                              value: _vm.selectedRoleId,
                              callback: function ($$v) {
                                _vm.selectedRoleId = $$v
                              },
                              expression: "selectedRoleId",
                            },
                          },
                          [
                            _c(
                              "span",
                              { attrs: { slot: "noResult" }, slot: "noResult" },
                              [_vm._v("No matching data")]
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm.services.length > 0
                ? _c(
                    "div",
                    { staticClass: "row mb-12" },
                    [
                      _vm._m(5),
                      _vm._l(_vm.services, function (service, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass:
                              "col-md-12 col-sm-12 col-xs-12 bt-border",
                          },
                          [
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col-sm-9 col-xs-8" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "pb-8 pt-8",
                                    class: {
                                      "link-disabled": _vm.type != "new_role",
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "checkbox inline-checkbox",
                                      },
                                      [
                                        _c("label", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: service.access,
                                                expression: "service.access",
                                              },
                                            ],
                                            attrs: {
                                              type: "checkbox",
                                              disabled: _vm.type != "new_role",
                                            },
                                            domProps: {
                                              value: service.access,
                                              checked: service.access,
                                              checked: Array.isArray(
                                                service.access
                                              )
                                                ? _vm._i(
                                                    service.access,
                                                    service.access
                                                  ) > -1
                                                : service.access,
                                            },
                                            on: {
                                              change: function ($event) {
                                                var $$a = service.access,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = service.access,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      _vm.$set(
                                                        service,
                                                        "access",
                                                        $$a.concat([$$v])
                                                      )
                                                  } else {
                                                    $$i > -1 &&
                                                      _vm.$set(
                                                        service,
                                                        "access",
                                                        $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          )
                                                      )
                                                  }
                                                } else {
                                                  _vm.$set(
                                                    service,
                                                    "access",
                                                    $$c
                                                  )
                                                }
                                              },
                                            },
                                          }),
                                          _c("span", {
                                            staticClass: "cr",
                                            class: {
                                              "cursor-not-allowed":
                                                _vm.type != "new_role",
                                            },
                                          }),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "cust_label",
                                        class: {
                                          "link-disabled":
                                            _vm.type != "new_role",
                                        },
                                      },
                                      [_vm._v(_vm._s(service.name))]
                                    ),
                                  ]
                                ),
                              ]),
                              _c(
                                "div",
                                {
                                  staticClass: "col-sm-3 col-xs-4",
                                  class: {
                                    "cursor-not-allowed":
                                      _vm.type != "new_role",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "edit-lnk cursor-pointer pb-8 pt-8",
                                      class: {
                                        "link-disabled pointer-events-edit":
                                          _vm.type != "new_role",
                                      },
                                      attrs: {
                                        disabled: _vm.type != "new_role",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.openPermissionsPopup(
                                            service
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(" edit ")]
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        )
                      }),
                    ],
                    2
                  )
                : _vm._e(),
            ]),
          ]),
          _c(
            "div",
            {
              staticClass:
                "col-sm-12 col-xs-12 col-md-12 footer remove_button_padding",
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "col-md-3 col-md-offset-6 col-sm-offset-5 col-sm-3 col-xs-5 xs-pd-lt-0",
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-block emergo-white-button",
                      attrs: { type: "button" },
                      on: { click: _vm.cancelPermissions },
                    },
                    [_vm._v(" Cancel ")]
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticClass:
                    "col-md-3 col-sm-4 col-xs-7 xs-pd-lt-0 xs-pd-rt-0",
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-block emergo-green-button",
                      attrs: {
                        type: "button",
                        disabled:
                          _vm.loaderStatus ||
                          _vm.role.role_id.toString().length == 0 ||
                          _vm.role.role_name.length == 0 ||
                          _vm.role.description.length == 0 ||
                          _vm.role.account_type.length == 0 ||
                          _vm.services.length == 0,
                      },
                      on: { click: _vm.saveRole },
                    },
                    [_vm._v(" Save ")]
                  ),
                ]
              ),
            ]
          ),
        ]),
      ]),
      _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
      _c("rbac-add-role-modules-modal", {
        attrs: { services: _vm.services, serviceId: _vm.serviceId },
        on: {
          updatePermissions: _vm.updatePermissions,
          updateServiceId: _vm.updateServiceId,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-sm-12 col-xs-12 col-md-12" }, [
      _c("div", { staticClass: "form-group" }, [
        _vm._v(" Role Id "),
        _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-sm-12 col-xs-12 col-md-12" }, [
      _c("div", { staticClass: "form-group" }, [
        _vm._v(" Name "),
        _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-sm-12 col-xs-12 col-md-12" }, [
      _c("div", { staticClass: "form-group" }, [
        _vm._v(" Description "),
        _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-sm-12 col-xs-12 col-md-12" }, [
      _c("div", { staticClass: "form-group" }, [
        _vm._v(" Account Type "),
        _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "col-sm-12 col-xs-12 col-md-12 form-group" },
      [
        _vm._v(" Copy Services "),
        _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "col-md-12 col-sm-12 col-xs-12 bt-border" },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-sm-8 col-xs-8" }, [
            _vm._v("Services access"),
          ]),
          _c("div", { staticClass: "col-sm-3 col-xs-3 txt-alg-rt" }, [
            _vm._v("Permissions"),
          ]),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }